import { useChatStore } from "@/stores/chatStore";
import {
  BUTTON_TAG,
  CLICK_ACTION,
  TRACK_EVENT,
  trackEvent,
} from "@/utils/analytics";
import { Badge, Typography } from "@castlery/fortress";
import { Communication } from "@castlery/fortress/Icons";
import { ProactiveGreeting } from "@/pages/chat/components/ProactiveGreeting";

export const CasaEntryButton: React.FC<{ enable: boolean }> = ({ enable }) => {
  const {
    hadUnreadMessage,
    setEntryPath,
    setCurrentView,
    openChat,
    setLoginInProgress,
    isOpeningChat,
  } = useChatStore();

  const handleChatButtonClick = async () => {
    if (isOpeningChat) return;

    trackEvent({
      event: TRACK_EVENT,
      category: "entry",
      action: CLICK_ACTION,
      tag: BUTTON_TAG,
      tag_value: "chat_now",
    });

    await openChat();
    setEntryPath("entry_button");
    setCurrentView("chatbox");
    setLoginInProgress(false);
  };

  return (
    <div className="fixed bottom-20 right-0 z-[1001]">
      <ProactiveGreeting enable={enable}>
        <button
          onClick={handleChatButtonClick}
          className="flex flex-col items-center justify-center w-[56px] h-[70px] border border-primary bg-[#844025] text-[20px] text-foreground"
          aria-label="Chat with us"
          style={{
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, .5)",
          }}
        >
          <Badge
            invisible={!hadUnreadMessage}
            color="warning"
            slotProps={{
              badge: {
                sx: {
                  top: "6px !important",
                  right: "6px !important",
                  minHeight: "8px !important",
                  minWidth: "8px !important",
                },
              },
            }}
          >
            <div className="w-8 h-8">
              <Communication
                sx={(theme) => ({
                  width: theme.spacing(6),
                  height: theme.spacing(6),
                })}
              />
            </div>
          </Badge>
          <Typography
            level="body2"
            sx={(theme) => ({
              color: theme.palette.brand.warmLinen[500],
            })}
          >
            Chat
          </Typography>
        </button>
      </ProactiveGreeting>
    </div>
  );
};
